import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="panel group flex h-full flex-col overflow-hidden rounded-lg transition-colors duration-300 hover:border-primary-500"
    >
      <div className="relative h-44 w-full overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} - 激情丛林电影资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-950/80 px-2.5 py-1 font-label text-[11px] text-accent-400 backdrop-blur">
          {item.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-50 transition-colors group-hover:text-accent-400">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2-custom text-sm leading-relaxed text-foreground-400">
          {item.excerpt}
        </p>
        <div className="mt-auto flex items-center gap-2 pt-4 font-label text-xs text-foreground-500">
          <i className="ri-calendar-line"></i>
          {item.date}
        </div>
      </div>
    </Link>
  );
}